import { r as registerInstance, h } from './index-5faac9d7.js';
import { t as tryParse, l as tryStringify } from './index-e29b327a.js';
import { h as getAnalyticsPageLoadData } from './helpers-c4d5ad02.js';
import { i as isEmpty_1 } from './isEmpty-51908328.js';
import { c as classnames } from './index-5d9a618b.js';
import { a as isBrowser } from './utils-6c8f178b.js';
import { a as processGlobalAnalyticsEvent } from './analytics-b6a65ffa.js';
import './currency-7be6806c.js';
import './lodash-bd96d09c.js';
import './_commonjsHelpers-11ca3be1.js';
import './analytics-205f1857.js';
import './_nodeUtil-f95b2b52.js';
import './_Stack-68736bd1.js';
import './tslib.es6-613ce1cd.js';
import './__node-resolve_empty-7dfe5913.js';
import './helpers-e12aa36b.js';
import './_isIndex-3036d479.js';
import './toNumber-6e3a0b09.js';
import './isSymbol-bae590b5.js';
import './index-e233ecdd.js';
import './toString-10b0f228.js';
import './number-57a50dcb.js';

const categoryHeadingCss = ".category-header{margin-bottom:32px;width:100%}@media screen and (min-width: 980px){.category-header{max-width:1200px;margin:0 auto 40px}}";

const CategoryHeading = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.name = undefined;
    this.description = undefined;
    this.readMoreLabel = undefined;
    this.readLessLabel = undefined;
    this.badge = undefined;
    this.sdlImageBlock = undefined;
    this._name = undefined;
    this._description = undefined;
    this._readMoreLabel = undefined;
    this._readLessLabel = undefined;
    this._badge = undefined;
    this._sdlImageBlock = undefined;
    this.imageSourceSets = undefined;
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    this.name = (_a = tryParse(this._name)) !== null && _a !== void 0 ? _a : this.name;
    this.description = (_b = tryParse(this._description)) !== null && _b !== void 0 ? _b : this.description;
    this.readMoreLabel = (_c = tryParse(this._readMoreLabel)) !== null && _c !== void 0 ? _c : this.readMoreLabel;
    this.readLessLabel = (_d = tryParse(this._readLessLabel)) !== null && _d !== void 0 ? _d : this.readLessLabel;
    this.badge = (_e = tryParse(this._badge)) !== null && _e !== void 0 ? _e : this.badge;
    this.sdlImageBlock = (_f = tryParse(this._sdlImageBlock)) !== null && _f !== void 0 ? _f : this.sdlImageBlock;
    this.imageSourceSets = (_j = (_h = (_g = this.sdlImageBlock) === null || _g === void 0 ? void 0 : _g.image) === null || _h === void 0 ? void 0 : _h.imageSourceSets) !== null && _j !== void 0 ? _j : [];
    window.scrollTo(0, 0);
  }
  render() {
    return (h("header", { class: "category-header" }, this.sdlImageBlock && this.imageSourceSets.length > 0 ? (h("pes-category-banner", { name: this.name, description: this.description, readMoreLabel: this.readMoreLabel, readLessLabel: this.readLessLabel, imageSourceSets: this.imageSourceSets })) : (h("pes-category-description", { name: this.name, description: this.description, readMoreLabel: this.readMoreLabel, readLessLabel: this.readLessLabel, badge: this.badge, isCategory: true }))));
  }
};
CategoryHeading.style = categoryHeadingCss;

const pesSprykerCategoryListingMainCss = ":host{display:block;box-sizing:border-box;width:100%}:host *,:host *::before,:host *::after{box-sizing:inherit}";

const PesSprykerCategoryListingMain = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.localeCode = undefined;
    this.subcategorySection = undefined;
    this.productsSection = undefined;
    this.filtersSection = undefined;
    this.hmcBanner = undefined;
    this.hideHMCBanner = false;
    this.hiddenSubcategoriesInfo = undefined;
    this.navigationState = '';
    this.filtersUrl = undefined;
    this.productsUrl = undefined;
    this.rangesUrl = undefined;
    this.numberOfProducts = undefined;
    this.showDocuments = undefined;
    this.showBuyOnline = true;
    this.enableCommerceConnector = true;
    this.avoidAccents = false;
    this.pageParam = undefined;
    this.analyticsPageData = undefined;
    this._localeCode = undefined;
    this._subcategorySection = undefined;
    this._productsSection = undefined;
    this._filtersSection = undefined;
    this._navigationState = undefined;
    this._filtersUrl = undefined;
    this._productsUrl = undefined;
    this._rangesUrl = undefined;
    this._numberOfProducts = undefined;
    this._hmcBanner = undefined;
    this._hideHMCBanner = undefined;
    this._showDocuments = undefined;
    this._showBuyOnline = undefined;
    this._enableCommerceConnector = undefined;
    this._avoidAccents = undefined;
    this._hiddenSubcategoriesInfo = undefined;
    this._pageParam = undefined;
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    this.localeCode = (_a = tryParse(this._localeCode)) !== null && _a !== void 0 ? _a : this.localeCode;
    this.subcategorySection = (_b = tryParse(this._subcategorySection)) !== null && _b !== void 0 ? _b : this.subcategorySection;
    this.productsSection = (_c = tryParse(this._productsSection)) !== null && _c !== void 0 ? _c : this.productsSection;
    this.filtersSection = (_d = tryParse(this._filtersSection)) !== null && _d !== void 0 ? _d : this.filtersSection;
    this.hmcBanner = (_e = tryParse(this._hmcBanner)) !== null && _e !== void 0 ? _e : this.hmcBanner;
    this.hideHMCBanner = (_f = tryParse(this._hideHMCBanner)) !== null && _f !== void 0 ? _f : this.hideHMCBanner;
    this.navigationState = (_g = tryParse(this._navigationState)) !== null && _g !== void 0 ? _g : this.navigationState;
    this.filtersUrl = (_h = tryParse(this._filtersUrl)) !== null && _h !== void 0 ? _h : this.filtersUrl;
    this.productsUrl = (_j = tryParse(this._productsUrl)) !== null && _j !== void 0 ? _j : this.productsUrl;
    this.rangesUrl = (_k = tryParse(this._rangesUrl)) !== null && _k !== void 0 ? _k : this.rangesUrl;
    this.numberOfProducts = (_l = tryParse(this._numberOfProducts)) !== null && _l !== void 0 ? _l : this.numberOfProducts;
    this.showDocuments = (_m = tryParse(this._showDocuments)) !== null && _m !== void 0 ? _m : this.showDocuments;
    this.showBuyOnline = (_o = tryParse(this._showBuyOnline)) !== null && _o !== void 0 ? _o : this.showBuyOnline;
    this.enableCommerceConnector = (_p = tryParse(this._enableCommerceConnector)) !== null && _p !== void 0 ? _p : this.enableCommerceConnector;
    this.avoidAccents = (_q = tryParse(this._avoidAccents)) !== null && _q !== void 0 ? _q : this.avoidAccents;
    this.hiddenSubcategoriesInfo = (_r = tryParse(this._hiddenSubcategoriesInfo)) !== null && _r !== void 0 ? _r : this.hiddenSubcategoriesInfo;
  }
  render() {
    return (h("pes-spryker-category-subcategory-listing", { localeCode: this.localeCode, subcategorySection: this.subcategorySection, productsSection: this.productsSection, filtersSection: this.filtersSection, hmcBanner: this.hmcBanner, hideHMCBanner: this.hideHMCBanner, navigationState: this.navigationState, filtersUrl: this.filtersUrl, productsUrl: this.productsUrl, rangesUrl: this.rangesUrl, numberOfProducts: this.numberOfProducts, showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, enableCommerceConnector: this.enableCommerceConnector, avoidAccents: this.avoidAccents, hiddenSubcategoriesInfo: this.hiddenSubcategoriesInfo, pageParam: this.pageParam, analyticsPageData: this.analyticsPageData }));
  }
};
PesSprykerCategoryListingMain.style = pesSprykerCategoryListingMainCss;

const pesSprykerCategoryListingMainWrapperCss = ":host{display:block;box-sizing:border-box;width:100%}:host *,:host *::before,:host *::after{box-sizing:inherit}";

const PesSprykerCategoryListingMainWrapper = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this._sprykerCategoryListingMain = undefined;
    this._hmcCategoryVisibility = undefined;
    this.sprykerCategoryListingMain = undefined;
    this.hmcCategoryVisibility = undefined;
    this.analyticsPageData = undefined;
  }
  componentWillLoad() {
    var _a, _b;
    this.analyticsPageData = getAnalyticsPageLoadData();
    this.sprykerCategoryListingMain = (_a = tryParse(this._sprykerCategoryListingMain)) !== null && _a !== void 0 ? _a : this.sprykerCategoryListingMain;
    this.hmcCategoryVisibility = (_b = tryParse(this._hmcCategoryVisibility)) !== null && _b !== void 0 ? _b : this.hmcCategoryVisibility;
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return (h("pes-spryker-category-listing-main", { localeCode: this.sprykerCategoryListingMain.localeCode, subcategorySection: this.sprykerCategoryListingMain.subcategorySection, productsSection: this.sprykerCategoryListingMain.productsSection, filtersSection: this.sprykerCategoryListingMain.filtersSection, hiddenSubcategoriesInfo: this.sprykerCategoryListingMain.hiddenSubcategoriesInfo, navigationState: this.sprykerCategoryListingMain.navigationState, filtersUrl: this.sprykerCategoryListingMain.filtersUrl, productsUrl: this.sprykerCategoryListingMain.productsUrl, rangesUrl: this.sprykerCategoryListingMain.rangesUrl, numberOfProducts: this.sprykerCategoryListingMain.numberOfProducts, showDocuments: this.sprykerCategoryListingMain.showDocuments, showBuyOnline: this.sprykerCategoryListingMain.showBuyOnline, enableCommerceConnector: this.sprykerCategoryListingMain.enableCommerceConnector, pageParam: this.sprykerCategoryListingMain.pageParam, hmcBanner: (_a = this.hmcCategoryVisibility) === null || _a === void 0 ? void 0 : _a.hmcBanner, hideHMCBanner: (_b = this.hmcCategoryVisibility) === null || _b === void 0 ? void 0 : _b.hideHMCBanner, avoidAccents: this.sprykerCategoryListingMain.avoidAccents, _localeCode: this.sprykerCategoryListingMain.localeCode, _subcategorySection: tryStringify(this.sprykerCategoryListingMain.subcategorySection), _productsSection: tryStringify(this.sprykerCategoryListingMain.productsSection), _filtersSection: tryStringify(this.sprykerCategoryListingMain.filtersSection), _hiddenSubcategoriesInfo: tryStringify(this.sprykerCategoryListingMain.hiddenSubcategoriesInfo), _navigationState: this.sprykerCategoryListingMain.navigationState, _filtersUrl: this.sprykerCategoryListingMain.filtersUrl, _productsUrl: this.sprykerCategoryListingMain.productsUrl, _rangesUrl: this.sprykerCategoryListingMain.rangesUrl, _numberOfProducts: this.sprykerCategoryListingMain.numberOfProducts, _showDocuments: String((_c = this.sprykerCategoryListingMain.showDocuments) !== null && _c !== void 0 ? _c : null), _showBuyOnline: String((_d = this.sprykerCategoryListingMain.showBuyOnline) !== null && _d !== void 0 ? _d : null), _enableCommerceConnector: String((_e = this.sprykerCategoryListingMain.enableCommerceConnector) !== null && _e !== void 0 ? _e : null), _pageParam: this.sprykerCategoryListingMain.pageParam, _hmcBanner: tryStringify((_f = this.hmcCategoryVisibility) === null || _f === void 0 ? void 0 : _f.hmcBanner), _hideHMCBanner: String((_h = (_g = this.hmcCategoryVisibility) === null || _g === void 0 ? void 0 : _g.hideHMCBanner) !== null && _h !== void 0 ? _h : null), _avoidAccents: String((_j = this.sprykerCategoryListingMain.avoidAccents) !== null && _j !== void 0 ? _j : null), analyticsPageData: this.analyticsPageData }));
  }
};
PesSprykerCategoryListingMainWrapper.style = pesSprykerCategoryListingMainWrapperCss;

const subcategoriesCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}.subcategories__listing{display:block;margin:0 auto;box-sizing:border-box;max-width:1200px;overflow:visible;color:#626469;display:flex;flex-direction:column;font-size:14px;line-height:20px;font-weight:400;background-color:#fafafa}.subcategories__listing *,.subcategories__listing *::before,.subcategories__listing *::after{box-sizing:inherit}.subcategories__listing *,.subcategories__listing *::before,.subcategories__listing *::after{box-sizing:inherit}@media screen and (min-width: 980px){.subcategories__listing{padding:0 10px;display:grid;grid-template-columns:minmax(260px, 300px) minmax(690px, 880px);grid-template-rows:auto auto}}.subcategories__banner-container--prerender{min-height:110px}.subcategories__banner-container{grid-column:2/3;grid-row:1/2}@media screen and (min-width: 980px){.subcategories__banner-container{margin-top:40px}}.subcategories__banner-container:not(:empty){margin-bottom:12px}.subcategories__aside-filters{padding:0 16px 16px}@media screen and (min-width: 980px){.subcategories__aside-filters{padding-left:0;padding-right:0;grid-column:1/2;grid-row:1/3}:host(:not([dir=\"rtl\"])) .subcategories__aside-filters{margin-right:20px}:host([dir=\"rtl\"]) .subcategories__aside-filters{margin-left:20px}}@media screen and (min-width: 980px){.subcategories__category-wrapper{width:100%;min-width:650px;max-width:900px;min-height:300px;grid-column:2/3;grid-row:2/3}}";

const Subcategories = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.getRangesCount = (subCategories) => {
      var _a;
      return (_a = subCategories === null || subCategories === void 0 ? void 0 : subCategories.reduce((sum, subCategory) => { var _a, _b; return ((_b = (_a = subCategory.ranges) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + sum; }, 0)) !== null && _a !== void 0 ? _a : 0;
    };
    this.name = undefined;
    this.sourceId = undefined;
    this.commonFiltersFilterBy = undefined;
    this.commonFiltersProductFiltersLabel = undefined;
    this.commonFiltersShowRanges = undefined;
    this.commonFiltersClearAllLabel = undefined;
    this.commonFiltersOfferTypeLabel = undefined;
    this.rangePartofLabel = undefined;
    this.rangeProductsViewDetailsLabel = undefined;
    this.productRelationsViewProdLabel = undefined;
    this.viewOnLabel = undefined;
    this.readMoreLabel = undefined;
    this.readLessLabel = undefined;
    this.newFilters = undefined;
    this.hmcBanner = undefined;
    this.hideHMCBanner = false;
    this.subCategories = undefined;
    this.avoidAccents = undefined;
    this.isPBS = false;
    this._name = undefined;
    this._sourceId = undefined;
    this._commonFiltersFilterBy = undefined;
    this._commonFiltersProductFiltersLabel = undefined;
    this._commonFiltersShowRanges = undefined;
    this._commonFiltersClearAllLabel = undefined;
    this._commonFiltersOfferTypeLabel = undefined;
    this._rangePartofLabel = undefined;
    this._rangeProductsViewDetailsLabel = undefined;
    this._productRelationsViewProdLabel = undefined;
    this._viewOnLabel = undefined;
    this._readMoreLabel = undefined;
    this._readLessLabel = undefined;
    this._newFilters = undefined;
    this._hmcBanner = undefined;
    this._hideHMCBanner = undefined;
    this._subCategories = undefined;
    this._avoidAccents = undefined;
    this.storageName = undefined;
    this.currentPageStorageKey = undefined;
    this.categoryId = undefined;
    this.filteredSubCategories = undefined;
    this.isMobileViewVisible = false;
    this.selectedSectionsCount = 0;
    this.productsCount = undefined;
  }
  onFilterStateChanged(event) {
    const { filtersState } = event.detail;
    const areAllUnchecked = Object.values(filtersState).every((state) => !state.value);
    if (areAllUnchecked) {
      this.filteredSubCategories = this.subCategories;
      this.selectedSectionsCount = 0;
    }
    else {
      this.filteredSubCategories = this.subCategories.filter((subCategory) => filtersState[subCategory.id].value);
      this.selectedSectionsCount = this.filteredSubCategories.length;
    }
    this.productsCount = this.getRangesCount(this.filteredSubCategories);
  }
  onToggleFilterMobileViewVisibility() {
    this.isMobileViewVisible = !this.isMobileViewVisible;
  }
  trackAnalyticsEventListener(e) {
    const { event } = e.detail;
    if (event === 'refinementStateChanged') {
      const { refinementId } = e.detail;
      const { value, parentCategoryId, rootSectionId, } = this.filtrationSmartData.entities.filter[refinementId];
      const extraParams = {
        filterCategory: rootSectionId,
        filterSubCategory: rootSectionId !== parentCategoryId ? parentCategoryId : undefined,
        filterName: value,
      };
      processGlobalAnalyticsEvent(e, extraParams);
    }
  }
  get viewProductsLabel() {
    var _a;
    return (_a = this.commonFiltersShowRanges) === null || _a === void 0 ? void 0 : _a.replace(' (#number of ranges#)', '');
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    this.name = (_a = tryParse(this._name)) !== null && _a !== void 0 ? _a : this.name;
    this.sourceId = (_b = tryParse(this._sourceId)) !== null && _b !== void 0 ? _b : this.sourceId;
    this.commonFiltersFilterBy = (_c = tryParse(this._commonFiltersFilterBy)) !== null && _c !== void 0 ? _c : this.commonFiltersFilterBy;
    this.commonFiltersProductFiltersLabel = (_d = tryParse(this._commonFiltersProductFiltersLabel)) !== null && _d !== void 0 ? _d : this.commonFiltersProductFiltersLabel;
    this.commonFiltersShowRanges = (_e = tryParse(this._commonFiltersShowRanges)) !== null && _e !== void 0 ? _e : this.commonFiltersShowRanges;
    this.commonFiltersClearAllLabel = (_f = tryParse(this._commonFiltersClearAllLabel)) !== null && _f !== void 0 ? _f : this.commonFiltersClearAllLabel;
    this.commonFiltersOfferTypeLabel = (_g = tryParse(this._commonFiltersOfferTypeLabel)) !== null && _g !== void 0 ? _g : this.commonFiltersOfferTypeLabel;
    this.rangePartofLabel = (_h = tryParse(this._rangePartofLabel)) !== null && _h !== void 0 ? _h : this.rangePartofLabel;
    this.rangeProductsViewDetailsLabel = (_j = tryParse(this._rangeProductsViewDetailsLabel)) !== null && _j !== void 0 ? _j : this.rangeProductsViewDetailsLabel;
    this.productRelationsViewProdLabel = (_k = tryParse(this._productRelationsViewProdLabel)) !== null && _k !== void 0 ? _k : this.productRelationsViewProdLabel;
    this.viewOnLabel = (_l = tryParse(this._viewOnLabel)) !== null && _l !== void 0 ? _l : this.viewOnLabel;
    this.readMoreLabel = (_m = tryParse(this._readMoreLabel)) !== null && _m !== void 0 ? _m : this.readMoreLabel;
    this.readLessLabel = (_o = tryParse(this._readLessLabel)) !== null && _o !== void 0 ? _o : this.readLessLabel;
    this.newFilters = (_p = tryParse(this._newFilters)) !== null && _p !== void 0 ? _p : this.newFilters;
    this.hmcBanner = (_q = tryParse(this._hmcBanner)) !== null && _q !== void 0 ? _q : this.hmcBanner;
    this.hideHMCBanner = (_r = tryParse(this._hideHMCBanner)) !== null && _r !== void 0 ? _r : this.hideHMCBanner;
    this.subCategories = (_s = tryParse(this._subCategories)) !== null && _s !== void 0 ? _s : this.subCategories;
    this.avoidAccents = (_t = tryParse(this._avoidAccents)) !== null && _t !== void 0 ? _t : this.avoidAccents;
    this.filteredSubCategories = (_u = this.subCategories) !== null && _u !== void 0 ? _u : [];
    this.productsCount = this.getRangesCount(this.subCategories);
    this.filtrationSmartData = this.normalizeFilters();
  }
  isHMCEnabled() {
    return !this.hideHMCBanner && !isEmpty_1(this.hmcBanner);
  }
  normalizeFilters() {
    const { refinements, filterCategory, filterSubCategory } = this.newFilters;
    const filter = refinements === null || refinements === void 0 ? void 0 : refinements.reduce((result, filterItem) => {
      const { label, sourceId } = filterItem;
      const hasSectionSingleFilter = refinements.length === 1;
      result[sourceId] = {
        label,
        value: sourceId,
        count: null,
        isChecked: hasSectionSingleFilter,
        isDisabled: hasSectionSingleFilter,
        rootSectionId: filterCategory,
        parentCategoryId: filterSubCategory,
      };
      return result;
    }, {});
    const entities = {
      filter,
      section: {
        [filterCategory]: {
          name: this.commonFiltersOfferTypeLabel,
          isCollapsible: false,
          type: 'multi',
          filters: refinements.map((refinement) => refinement.sourceId),
          sections: [],
          rootSectionId: filterCategory,
          parentCategoryId: filterSubCategory,
        },
      },
    };
    const result = {
      entities,
      result: this.subCategories.length ? [filterCategory] : [],
    };
    return result;
  }
  renderFilters() {
    return (h("pes-responsive-filters", { filtrationSmartData: this.filtrationSmartData, resetButtonLabel: this.commonFiltersClearAllLabel, visibleRefinementsPerFacetCount: Infinity, headerLabelDesktop: this.commonFiltersFilterBy, headerLabelMobile: this.commonFiltersProductFiltersLabel, viewProductsLabel: this.viewProductsLabel, isMobileViewVisible: this.isMobileViewVisible, isMobileCategorySelected: true, selectedSectionsCount: this.selectedSectionsCount, productsCount: this.productsCount, categories: [], onShowMobileFilter: () => (this.isMobileViewVisible = true) }));
  }
  render() {
    var _a;
    return (h("main", { class: "subcategories__listing" }, h("div", { class: classnames('subcategories__banner-container', {
        'subcategories__banner-container--prerender': this.isHMCEnabled() && this.hmcBanner,
      }) }, this.isHMCEnabled() && isBrowser() && (h("pes-hmc-banner", { categoryName: this.hmcBanner.categoryName, labels: this.hmcBanner.labels, sourceId: this.hmcBanner.pimId, categoryProductConfiguratorUrl: this.hmcBanner.categoryProductConfiguratorUrl, hasQuestionnaire: this.hmcBanner.hasQuestionnaire, questionnaireUrl: this.hmcBanner.questionnaireUrl, rangeTooltipUrl: this.hmcBanner.rangeTooltipUrl, selectorConfigUrl: this.hmcBanner.selectorConfigUrl, isExternalProductConfiguratorUrl: this.hmcBanner.isExternalProductConfiguratorUrl, hmcHost: this.hmcBanner.host, token: this.hmcBanner.token, channel: this.hmcBanner.channel, pageSource: this.hmcBanner.pageSource }))), h("aside", { class: "subcategories__aside-filters" }, this.renderFilters()), h("aside", { class: "subcategories__category-wrapper" }, h("pes-subcategory-list", null, (_a = this.filteredSubCategories) === null || _a === void 0 ? void 0 : _a.map((subcategory, id) => (h("pes-subcategory-block", { slot: "pes-subcategory-block", key: subcategory.id, subCategory: subcategory, rangePartofLabel: this.rangePartofLabel, viewOnLabel: this.viewOnLabel, productRelationsViewProdLabel: this.productRelationsViewProdLabel, rangeProductsViewDetailsLabel: this.rangeProductsViewDetailsLabel, readMoreLabel: this.readMoreLabel, readLessLabel: this.readLessLabel, avoidAccents: this.avoidAccents, isFirstBlock: id === 0, currentPageStorageKey: this.currentPageStorageKey, storageName: this.storageName })))))));
  }
};
Subcategories.style = subcategoriesCss;

const PesSubcategoriesWrapper = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this._sprykerCategoryMain = undefined;
    this._hmcCategoryVisibility = undefined;
    this.sprykerCategoryMain = undefined;
    this.hmcCategoryVisibility = undefined;
  }
  componentWillLoad() {
    var _a, _b;
    this.sprykerCategoryMain = (_a = tryParse(this._sprykerCategoryMain)) !== null && _a !== void 0 ? _a : this.sprykerCategoryMain;
    this.hmcCategoryVisibility = (_b = tryParse(this._hmcCategoryVisibility)) !== null && _b !== void 0 ? _b : this.hmcCategoryVisibility;
  }
  render() {
    var _a, _b, _c, _d;
    return (h("pes-subcategories", { name: this.sprykerCategoryMain.name, sourceId: this.sprykerCategoryMain.sourceId, commonFiltersFilterBy: this.sprykerCategoryMain.commonFiltersFilterBy, commonFiltersProductFiltersLabel: this.sprykerCategoryMain.commonFiltersProductFiltersLabel, commonFiltersShowRanges: this.sprykerCategoryMain.commonFiltersShowRanges, commonFiltersClearAllLabel: this.sprykerCategoryMain.commonFiltersClearAllLabel, commonFiltersOfferTypeLabel: this.sprykerCategoryMain.commonFiltersOfferTypeLabel, rangePartofLabel: this.sprykerCategoryMain.rangePartofLabel, rangeProductsViewDetailsLabel: this.sprykerCategoryMain.rangeProductsViewDetailsLabel, productRelationsViewProdLabel: this.sprykerCategoryMain.productRelationsViewProdLabel, viewOnLabel: this.sprykerCategoryMain.viewOnLabel, readMoreLabel: this.sprykerCategoryMain.readMoreLabel, readLessLabel: this.sprykerCategoryMain.readLessLabel, newFilters: this.sprykerCategoryMain.newFilters, hmcBanner: (_a = this.hmcCategoryVisibility) === null || _a === void 0 ? void 0 : _a.hmcBanner, hideHMCBanner: (_b = this.hmcCategoryVisibility) === null || _b === void 0 ? void 0 : _b.hideHMCBanner, subCategories: this.sprykerCategoryMain.subCategories, avoidAccents: this.sprykerCategoryMain.avoidAccents, _name: this.sprykerCategoryMain.name, _sourceId: this.sprykerCategoryMain.sourceId, _commonFiltersFilterBy: this.sprykerCategoryMain.commonFiltersFilterBy, _commonFiltersProductFiltersLabel: this.sprykerCategoryMain.commonFiltersProductFiltersLabel, _commonFiltersShowRanges: this.sprykerCategoryMain.commonFiltersShowRanges, _commonFiltersClearAllLabel: this.sprykerCategoryMain.commonFiltersClearAllLabel, _commonFiltersOfferTypeLabel: this.sprykerCategoryMain.commonFiltersOfferTypeLabel, _rangePartofLabel: this.sprykerCategoryMain.rangePartofLabel, _rangeProductsViewDetailsLabel: this.sprykerCategoryMain.rangeProductsViewDetailsLabel, _productRelationsViewProdLabel: this.sprykerCategoryMain.productRelationsViewProdLabel, _viewOnLabel: this.sprykerCategoryMain.viewOnLabel, _readMoreLabel: this.sprykerCategoryMain.readMoreLabel, _readLessLabel: this.sprykerCategoryMain.readLessLabel, _newFilters: tryStringify(this.sprykerCategoryMain.newFilters), _hmcBanner: tryStringify((_c = this.hmcCategoryVisibility) === null || _c === void 0 ? void 0 : _c.hmcBanner), _hideHMCBanner: String(((_d = this.hmcCategoryVisibility) === null || _d === void 0 ? void 0 : _d.hideHMCBanner) || false), _subCategories: tryStringify(this.sprykerCategoryMain.subCategories), _avoidAccents: String(this.sprykerCategoryMain.avoidAccents || false) }));
  }
};

export { CategoryHeading as pes_category_heading, PesSprykerCategoryListingMain as pes_spryker_category_listing_main, PesSprykerCategoryListingMainWrapper as pes_spryker_category_listing_main_wrapper, Subcategories as pes_subcategories, PesSubcategoriesWrapper as pes_subcategories_wrapper };
